<template>
  <div>
    <v-btn block color="primary" class="my-2" @click="setBloomTimeRange()">Kiwi Flowering Period</v-btn>
    <v-btn block color="primary" class="my-2" @click="setTreeDaysTimeRange()">Last 3 Days</v-btn>
    <v-btn block color="primary" class="mb-2" @click="setLastMonthTimeRange()">Last 30 Days</v-btn>
    <v-btn block color="primary" class="mb-4" @click="setLastYearTimeRange()" >Last Year</v-btn>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dateRangeText"
          label="Time Range"
          prepend-icon="event"
          readonly
          v-on="on"
          ></v-text-field>
      </template>
      <v-date-picker v-model="dates" value="YYYY" locale="it" first-day-of-week="1" @change="updateDates" no-title reactive range scrollable>
        <v-btn text color="primary" @click="$refs.menu.save(dates)">Close</v-btn>
      </v-date-picker>
    </v-menu>
    <v-select
      v-model="dataResolution"
      :items="resolutions"
      label="Data Resolution"
      item-text="text"
      item-value="value"
      return-object
      @change="updateResolution" 
      ></v-select>
  </div>
</template>

<style>
.time-range{
  height: 100%;
}
</style>

<script>
export default {
  name: "TimeRange",
  data: () => ({
    dates: [new Date(new Date().getTime() - (3*24*60*60*1000)).toISOString().substr(0, 10), new Date().toISOString().substr(0, 10) ], // last 3 days
    dateRangeText : '',
    resolutions: [
      {text:'15 Min', value:'15m'},
      {text:'1 Hour', value:'1h'},
      {text:'1 Day', value: '1d'},
      {text: '1 Month', value: '1_MONTH'}
    ],
    dataResolution: {text:'1 Hour', value:'1h'},
    menu: false,
    modal: false
  }),
  created: function () {
    this.updateDates()
  },
  methods:{ 
    updateResolution(){
      this.$emit("dateRange",{dates: this.dates, resolution: this.dataResolution})
    },
    updateDates(){
      if (Array.isArray(this.dates)) this.dates.sort() 
      this.dataResolution = this.getDataResolution() 
      this.dateRangeText = this.dates.join(" -> ")
      this.$emit("dateRange",{dates: this.dates, resolution: this.dataResolution})
    },
    setBloomTimeRange(){
      let now = new Date()
      this.dates[0] = new Date( now.getFullYear(), 4, 1, 0, 0, 0, 0).toISOString().substr(0, 10)
      this.dates[1] = new Date( now.getFullYear(), 6, 1, 0, 0, 0, 0).toISOString().substr(0, 10)
      this.dataResolution = this.getDataResolution() 
      this.updateDates()
    },
    setLastYearTimeRange(){
      let now = new Date()
      this.dates[0] = new Date( now.getFullYear() -1, now.getMonth(), now.getDay(), 0, 0, 0, 0).toISOString().substr(0, 10)
      this.dates[1] = now.toISOString().substr(0, 10)
      this.dataResolution = this.getDataResolution() 
      this.updateDates()
    },
    setLastMonthTimeRange(){
      let now = new Date()
      this.dates[0] = new Date( now.getFullYear(), (now.getMonth()-1)%12, now.getDay(), 0, 0, 0,0).toISOString().substr(0, 10)
      this.dates[1] = now.toISOString().substr(0, 10)
      this.dataResolution = this.getDataResolution() 
      this.updateDates()
    },
    setTreeDaysTimeRange(){
      let now = new Date()
      this.dates = [new Date(now.getTime() - (3*24*60*60*1000)).toISOString().substr(0, 10), now.toISOString().substr(0, 10) ], // last 3 days
      this.updateDates()
    },
    getDataResolution() {
      const oneDay = 24 * 60 * 60 * 1000;
      let fromDate = new Date(this.dates[0])
      let toDate = new Date(this.dates[1])
      const daySpan = Math.abs((fromDate - toDate) / oneDay)
      if (daySpan < 4) return {value: '15m', text: '15 Minutes'}
      if (daySpan < 15 && daySpan >= 4) return {value:'1h', text: '1 Hour'}
      if (daySpan < 65 && daySpan >= 15) return {value:'1d', text: '1 Day'}
      return {value: '1_MONTH', text: '1 Month'}
    }
  }
}
</script>
